// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { handleSignOut } from '@/lib/helpers/handle-sign-out';
import { ORIGIN_STRING } from '@/lib/constants';
import { ProfileData } from '@/lib/types/api/profile-data';
import { setRedirectCookie } from '@/lib/helpers/utils';
import { ssoLogoutLink } from '@/lib/helpers/sso-links';

// components
import CookieSettings from '@/components/CookieSettings/CookieSettings';
import NavLink from '@/components/Navigation/NavLink';
import UserImageInitial from '@/components/Navigation/UserImageInitial';

// styles
import styles from './MobileMenu.module.scss';

// svgs
import BackIcon from '@/public/svg/caret-prev.svg';
import NextIcon from '@/public/svg/caret-next.svg';

interface MobileMenuUserProps {
  isLocalized: boolean;
  isStationPassportEnabled: boolean;
  ketchEnabled?: boolean;
  onClick: () => void;
  profile: ProfileData;
  setUserSettingsOpen: (open: boolean) => void;
  userSettingsOpen: boolean;
}

const MobileMenuUser = (props: MobileMenuUserProps) => {
  const {
    isLocalized,
    isStationPassportEnabled,
    ketchEnabled,
    onClick,
    profile,
    setUserSettingsOpen,
    userSettingsOpen,
  } = props;

  return (
    <>
      <button
        onClick={() => setUserSettingsOpen(!userSettingsOpen)}
        className={styles.user_settings_toggle_button}
        aria-expanded={userSettingsOpen}
      >
        <UserImageInitial
          profile={profile}
          className={styles.mobile_menu_user_image_initial}
        data-sentry-element="UserImageInitial" data-sentry-source-file="MobileMenuUser.tsx" />

        {profile.profile?.first_name} {profile.profile?.last_name}

        { !userSettingsOpen && (
          <NextIcon />
        )}
      </button>

      <div className={styles.user_settings_submenu} aria-hidden={!userSettingsOpen}>

        <button
          onClick={() => setUserSettingsOpen(!userSettingsOpen)}
          aria-label="Close Settings Menu"
          className={styles.user_settings_submenu_button_title}
        >
          <BackIcon data-sentry-element="BackIcon" data-sentry-source-file="MobileMenuUser.tsx" />
          Settings
        </button>

        <ul>
          <li>
            <a
              href={`${ORIGIN_STRING}/sso/profile-link`}
              onClick={() => setRedirectCookie()}
            >
              Account
            </a>
          </li>
          <li>
            <NavLink
              href="/settings/site-settings/"
              onClick={onClick}
            data-sentry-element="NavLink" data-sentry-source-file="MobileMenuUser.tsx">
              Site Settings
            </NavLink>
          </li>
        {(isLocalized && isStationPassportEnabled) && (
          <li >
            <NavLink
              href="/settings/membership-settings/"
              onClick={onClick}
            >
              Membership & Passport
            </NavLink>
          </li>
        )}

        { ketchEnabled && (
          <li>
            <CookieSettings
              text="Privacy Settings"
            />
          </li>
        )}

          <li>
            <a
              href={ssoLogoutLink}
              onClick={handleSignOut}
              className={styles.sign_out}
            >
              Sign Out
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default MobileMenuUser;
